export default "__VITE_ASSET__BunuZHJn__"